import { render, staticRenderFns } from "./TheWrapper.vue?vue&type=template&id=69742999&"
import script from "./TheWrapper.vue?vue&type=script&lang=js&"
export * from "./TheWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TheWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports